import { render, staticRenderFns } from "./ChangeRequestState.vue?vue&type=template&id=68fc1f42&"
import script from "./ChangeRequestState.vue?vue&type=script&lang=js&"
export * from "./ChangeRequestState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports